module.exports = __webpack_public_path__ + "img/logo_select.16b4a2ed.png";